import { createContext } from 'react';

export const LanguageContext = createContext('es_ES');